import React from 'react';
import Select, { components } from 'react-select';

interface ICustomSelectCheckbox {
    ref?: any;
    options: Array<any>;
    selectedOption?: string | string[] | any;
    onChangeSelectedOption: (e: any, type?: string, index?: any, parent?: any) => void;
    multiple?: boolean;
    placeholder?: string;
    error?: string;
    selectStyle?: any;
    placeholderStyle?: any;
    singleValueStyle?: any;
    dropDownIndicatorStyle?: any;
    indicatorSeparatorStyle?: any;
    containerStyle?: string;
    uniqueName?: string;
    name?: string;
    isLoading?: boolean;
    disabled?: boolean;
    index?: any;
    loadingOptions?: boolean;
    dynamicOptions?: boolean;
    showFixed?: boolean;
    dataQa?: string;
    parent?: any;
    onHandleKeyDown?: (e: any, type?: string, index?: any, parent?: any) => void;
    onChangeValue?: (e: any, type?: string, index?: any, parent?: any) => void;
    onMenuClose?: (type?: string, index?: any, parent?: any) => void;
}

const CustomSelectCheckbox = ({
    ref,
    options,
    parent,
    selectedOption,
    multiple,
    placeholder,
    error,
    containerStyle,
    selectStyle,
    indicatorSeparatorStyle,
    dropDownIndicatorStyle,
    placeholderStyle,
    singleValueStyle,
    uniqueName,
    name,
    isLoading,
    showFixed,
    dataQa,
    index,
    loadingOptions,
    disabled,
    dynamicOptions,
    onChangeSelectedOption,
    onChangeValue,
    onMenuClose,
    onHandleKeyDown
}: ICustomSelectCheckbox) => {
    const customStyles = {
        control: (base: any, state: any) => ({
            ...base,
            boxShadow: 'none',
            borderColor: error ? 'red' : '#00330F',
            paddingTop: 2,
            backgroundColor: "#00330F",
            paddingBottom: 2,
            '&:hover': {
                borderColor: '#00330F !important',
                cursor: 'pointer'
            },
            ...selectStyle || {}
        }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: "#00330F",
            color: "#fff",
            maxHeight: 130
        }),
        menuList: (base: any) => ({
            ...base,
            color: "#fff",
            maxHeight: 130,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#ffffff #00330F',
            '&::-webkit-scrollbar': {
                width: '6px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#00330F',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#ffffff',
                borderRadius: '6px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#ddd',
            }
        }),
        option: (base: any, state: any) => ({
            ...base,
            color: state.isFocused ? '#00330F' : '#fff',
            backgroundColor: state.isFocused ? '#ffffff' : '#00330F',
            padding: '10px',
            borderBottom: '1px solid white',
            '&:hover': {
                color: '#00330F',
                backgroundColor: '#ffffff',
                cursor: 'pointer'
            },
            '&:focus': {
                color: '#00330F',
                backgroundColor: '#ffffff',
                cursor: 'pointer'
            },
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            ...indicatorSeparatorStyle || {},
            display: 'none',
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            ...dropDownIndicatorStyle || {},
            color: '#fff',
            '&:hover': {
                color: '#fff',
            },
        }),
        placeholder: (base: any) => ({
            ...base,
            ...placeholderStyle || {},
            color: "#fff",
            fontWeight: 'bold'
        }),
        singleValue: (base: any) => ({
            ...base,
            ...singleValueStyle || {},
            borderBottom: "0px solid white",
            color: "#fff",
            '&:hover': {
                color: "#fff"
            },
        }),
    };

    const Input = (props: any) => {
        return <components.Input {...props} data-qa={dataQa || ''} />;
    };

    return (
        <div className={`checkbox-select ${containerStyle || 'mb-3 w-full'} bg-[#00330F] p-1 !rounded min-w-[250px]`}>
            {name && <p className='mb-1 text-[#fff] pl-3'>{name}</p>}
            <Select
                ref={ref}
                menuPosition={showFixed ? 'fixed' : 'absolute'}
                placeholder={placeholder}
                value={selectedOption || null}
                onChange={(e) => onChangeSelectedOption(e, uniqueName, index, parent)}
                options={loadingOptions ? [] : options || []}
                styles={customStyles}
                components={{ Input }}
                noOptionsMessage={() => loadingOptions ? 'Loading...' : 'No Options'}
                onInputChange={(e) => onChangeValue?.(e, uniqueName, index, parent)}
                isDisabled={isLoading || disabled || false}
                isLoading={isLoading || false}
                isSearchable={options?.length > 0 || dynamicOptions}
                isMulti={multiple || false}
                onKeyDown={(e) => onHandleKeyDown?.(e, uniqueName, index, parent)}
                onMenuClose={() => onMenuClose?.(uniqueName, index, parent)} />
        </div>
    )
}

export default CustomSelectCheckbox;
